import { render, staticRenderFns } from "./IMViewApproval.vue?vue&type=template&id=5e991c44&scoped=true&lang=pug"
import script from "./IMViewApproval.vue?vue&type=script&lang=js"
export * from "./IMViewApproval.vue?vue&type=script&lang=js"
import style0 from "./IMViewApproval.vue?vue&type=style&index=0&id=5e991c44&prod&scoped=true&lang=css"
import style1 from "./IMViewApproval.vue?vue&type=style&index=1&id=5e991c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e991c44",
  null
  
)

export default component.exports